import _ from "underscore";
import RegistrationService from "../services/registrationService";
import UserService from "../services/userService";

const generateUsernameFromName = (fname, sname) => {
  let username = fname.replace(/\s+/, "") + "." + sname.replace(/\s+/, "");
  while (username.length < 5) {
    username += "0";
  }
  return username
    .replace(/[åä]/g, "a")
    .replace(/[ÅÄ]/g, "A")
    .replace(/ö/g, "o")
    .replace(/Ö/g, "O")
    .toLowerCase();
};

function findFreeUsername(getstate, dispatch, username, counter) {
  return new Promise((resolve, reject) => {
    function findUN(getstate, dispatch, username, counter) {
      UserService.validateByKey(
        "username",
        username + counter,
        getstate().config.server,
        dispatch
      )
        /* username is unique */
        .then(() => {
          resolve(username + counter);
        })
        /* username is not unique */
        .catch(() => {
          if (counter === "") {
            counter = 1;
          } else {
            counter = counter + 1;
          }
          findUN(getstate, dispatch, username, counter);
        });
    }
    findUN(getstate, dispatch, username, counter);
  });
}

export function registration(values) {
  return (dispatch, getstate) => {
    var payload = {};

    dispatch({ type: "REGISTRATION_INIT" });

    if (!_.isEmpty(values.username)) payload["username"] = values.username;
    if (!_.isEmpty(values.email)) payload["email1"] = values.email;
    if (!_.isEmpty(values.password1)) payload["password"] = values.password1;
    if (!_.isEmpty(values.firstname)) payload["fname"] = values.firstname;
    if (!_.isEmpty(values.lastname)) payload["sname"] = values.lastname;
    if (!_.isEmpty(values.address)) payload["address"] = values.address;
    if (!_.isEmpty(values.postcode)) payload["postcode"] = values.postcode;
    if (!_.isEmpty(values.city)) payload["city"] = values.city;
    if (!_.isEmpty(values.sipaddress))
      payload["sipaddress"] = values.sipaddress;
    if (!_.isEmpty(values.phonenumber))
      payload["phonenumber"] = values.phonenumber;
    if (!_.isEmpty(values.mobilenumber))
      payload["mobilephone"] = values.mobilenumber;
    if (!_.isEmpty(values.textphonenumber))
      payload["textphonenumber"] = values.textphonenumber;
    if (!_.isEmpty(values.isdnnumber))
      payload["isdnnumber"] = values.isdnnumber;
    if (!_.isEmpty(values.gggnumber))
      payload["mobile3Gnumber"] = values.gggnumber;
    if (!_.isEmpty(values.faxnumber)) payload["faxnumber"] = values.faxnumber;
    if (!_.isEmpty(values.orgID)) {
      payload["orgID"] = values.orgID;
    } else {
      payload["orgID"] = getstate().config.registration.orgid;
    }

    if (
      _.isEmpty(values.lastname) &&
      _.isEmpty(values.firstname) &&
      _.isEmpty(values.sipaddress) &&
      !_.isEmpty(values.username)
    ) {
      payload["sipaddress"] = values.username;
    }

    if (!payload["username"]) {
      if (!_.isEmpty(values.firstname) && !_.isEmpty(values.lastname)) {
        findFreeUsername(
          getstate,
          dispatch,
          generateUsernameFromName(values.firstname, values.lastname),
          ""
        ).then(username => {
          payload["username"] = username;
          dispatch(sendRegistration(payload));
        });
      } else if (!_.isEmpty(values.email)) {
        findFreeUsername(
          getstate,
          dispatch,
          values.email.split("@")[0],
          ""
        ).then(username => {
          payload["username"] = username;
          dispatch(sendRegistration(payload));
        });
      } else if (!_.isEmpty(values.sipaddress)) {
        findFreeUsername(
          getstate,
          dispatch,
          values.sipaddress.split("@")[0],
          ""
        ).then(username => {
          payload["username"] = username;
          dispatch(sendRegistration(payload));
        });
      }
    } else {
      dispatch(sendRegistration(payload));
    }
  };
}

function sendRegistration(payload) {
  return (dispatch, getstate) => {
    var agp =
      getstate().config.registration.autogeneratepassword ||
      payload.password === undefined
        ? "true"
        : "false";
    var sendRegistrationMail = getstate().config.registration
      .sendRegistrationMail
      ? "true"
      : "false";
    var lang = encodeURIComponent(navigator.language);
    let params = {
      generatePassword: agp,
      sendRegistrationMail: sendRegistrationMail,
      lang: lang,
    };

    RegistrationService.createUser(
      JSON.stringify(payload),
      params,
      getstate().config.server,
      dispatch
    )
      .done(() => {
        dispatch({ type: "REGISTRATION_SUCCESS" });
      })
      .fail((xhr, ajaxOptions, thrownError) => {
        dispatch({ type: "REGISTRATION_ERROR", payload: thrownError });
      });
  };
}

export function init(orgid) {
  return (dispatch, getstate) => {
    if (!orgid) {
      orgid = getstate().config.registration.orgid;
    }

    let params = { id: orgid };

    RegistrationService.getOrgSettings(
      params,
      getstate().config.server,
      dispatch
    ).done(data => {
      var properties = {};
      data.settings.map(function(element) {
        properties[element.key] = element.value;
        return true;
      });

      dispatch({
        type: "CONFIG_INIT_REGISTRATION",
        payload: {
          ...properties,
          config: getstate().config,
        },
      });
    });
  };
}






// WEBPACK FOOTER //
// ./src/actions/registrationActions.js